import React, {useState, useEffect, useRef, useContext} from 'react';
import sharedStyles from "../UserModals.module.css";
import stylesSuccess from "../Success/Success.module.css";
import styles from "./RegistrationFrom.module.css"
import sharedInputStyles from '../../../adds/AddCreateForm/AddCreateForm.module.css'
import ToastNotification from "../ToastNotification/ToastNotification";
import {login, loginByCode, registration, sendLoginCode} from "../../../../http/userApi";
import {useHistory} from "react-router-dom";
import {Context} from "../../../../index";
import {SHOP_ROUTE} from "../../../../utils/consts";


const RegistrationForm = ({ show, onHide }) => {

    const history = useHistory();
    const { user } = useContext(Context);

    const [step, setStep] = useState(1); // 1, 2 или 3
    const [isRegister, setIsRegister] = useState(false); // false = login, true = register
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [code, setCode] = useState(Array(4).fill(""));
    const [isAgreementChecked, setIsAgreementChecked] = useState(false);

    const [toast, setToast] = useState(null);

    const codeRefs = useRef([]);

    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (show) {
            const timeout = setTimeout(() => setVisible(true), 10);
            return () => clearTimeout(timeout);
        } else {
            setVisible(false);
            setStep(1);
            setIsRegister(false);
            setEmail('');
            setPassword('');
            setConfirmPassword('');
            setCode(Array(4).fill(""));
        }
    }, [show]);

    if (!show && !visible) return null;

    // универсальный показ тоста
    const showToast = (message, type = "error") => {
        setToast({ id: Date.now(), message, type });
    };

    // Переключение кода
    const handleCodeChange = (value, idx) => {
        if (/^\d?$/.test(value)) {
            const newCode = [...code];
            newCode[idx] = value;
            setCode(newCode);

            // автофокус на следующий инпут
            if (value && idx < code.length - 1) {
                codeRefs.current[idx + 1]?.focus();
            }

            // если это последний инпут и введена цифра — сразу отправляем
            if (idx === code.length - 1 && value) {
                const fullCode = newCode.join("");
                if (fullCode.length === code.length) {
                    handleCodeSubmit(newCode); // передаем актуальное значение
                }
            }
        }
    };

    // Валидация
    const handleContinueEmail = async () => {
        if (!email.trim()) {
            showToast("Введите email", "error");
            return;
        }

        if (isRegister && !isAgreementChecked) {
            showToast("Необходимо согласие на обработку персональных данных", "error");
            return;
        }

        if (isRegister){
            try {
                // 1. 🔥 Вызываем асинхронную функцию бэкенда
                const response = await registration(email);

                // 2. УСПЕХ: Показываем сообщение от бэкенда (например: 'Код для входа отправлен на почту.')
                // и только ПОСЛЕ этого переключаем шаг
                showToast(response.message || "Код отправлен! Проверьте почту.", "success");
                setStep(3);
                setCode(Array(4).fill("")); // Очищаем поле для кода

            } catch (e) {
                // 3. ОШИБКА: Показываем тост с сообщением об ошибке
                const errorMessage = e.message || "Ошибка отправки кода. Попробуйте еще раз.";
                showToast(errorMessage, "error");
            }
        } else {
            try {
                // 1. 🔥 Вызываем асинхронную функцию бэкенда
                const response = await sendLoginCode(email);

                // 2. УСПЕХ: Показываем сообщение от бэкенда (например: 'Код для входа отправлен на почту.')
                // и только ПОСЛЕ этого переключаем шаг
                showToast(response.message || "Код отправлен! Проверьте почту.", "success");
                setStep(3);
                setCode(Array(4).fill("")); // Очищаем поле для кода

            } catch (e) {
                // 3. ОШИБКА: Показываем тост с сообщением об ошибке
                const errorMessage = e.message || "Ошибка отправки кода. Попробуйте еще раз.";
                showToast(errorMessage, "error");
                // Остаемся на Шаге 1, чтобы пользователь мог исправить email
            }
        }
    };

    const handlePasswordSubmit = async () => {
        if (!email.trim()) {
            showToast("Введите email", "error");
            return;
        }
        if (!password.trim()) {
            showToast("Введите пароль", "error");
            return;
        }
        if (isRegister && password !== confirmPassword) {
            showToast("Пароли не совпадают", "error");
            return;
        }

        if (isRegister && !isAgreementChecked) {
            showToast("Необходимо согласие на обработку персональных данных", "error");
            return;
        }

        if (isRegister){
            try {
                const response = await registration(email, email, password);
                showToast(response.message || "Письмо с подтверждением отправлено на вашу почту", "success");
                setStep(4)
            } catch (e) {
                const errorMessage = e.message || "Ошибка отправки кода. Попробуйте еще раз.";
                showToast(errorMessage, "error");
            }
        } else {
            try {
                const response = await login(email, password);
                onHide();
                window.location.href = `/profile/${response.id}`;
                showToast(response.message || "Вход успешен!", "success");
            } catch (e) {
                const errorMessage = e.message || "Ошибка отправки кода. Попробуйте еще раз.";
                showToast(errorMessage, "error");
            }
        }
    };

    const handleCodeSubmit = async (currentCode = null) => {
        const codeToCheck = currentCode ? currentCode.join("") : code.join("");

        if (codeToCheck.length !== 4) {
            showToast("Введите все 4 цифры", "error");
            return;
        }

        try {
            const userData = await loginByCode(email, codeToCheck);

            // Обновляем MobX стор
            user.setIsAuth(true);
            user.setUserData(userData);

            showToast(`Вход успешен! Добро пожаловать, ${userData.email || 'пользователь'}!`, "success");

            // Редирект на SHOP_ROUTE
            history.push(SHOP_ROUTE);

            // Закрываем модалку
            onHide();
        } catch (e) {
            const errorMessage = e.message || "Ошибка входа. Проверьте код и срок действия.";
            showToast(errorMessage, "error");

            setCode(Array(4).fill(""));
            if (codeRefs.current[0]) codeRefs.current[0].focus();
        }
    };

    const handleResendCode = async () => {
        if (!email.trim()) {
            showToast("Введите email", "error");
            return;
        }

        try {
            const response = await sendLoginCode(email);
            showToast(response.message || "Код отправлен повторно! Проверьте почту.", "success");
            setCode(Array(4).fill("")); // очищаем поле ввода кода
            codeRefs.current[0]?.focus(); // возвращаем фокус на первый инпут
        } catch (e) {
            const errorMessage = e.message || "Ошибка отправки кода. Попробуйте еще раз.";
            showToast(errorMessage, "error");
        }
    };

    return (
        <div className={`${sharedStyles.modal} ${visible ? sharedStyles.active : ''}`} onClick={onHide}>
            <div className={`${sharedStyles.modalContent} ${stylesSuccess.modalSuccess}`} onClick={e => e.stopPropagation()}>
                <div className={sharedStyles.customCloseButton} onClick={onHide}>
                    &times;
                </div>

                {/* кружочки */}
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleBigCircleLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleTopRight}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomLeft}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleBottomRight}`}></div>
                <div className={`${sharedStyles.bgCircle} ${sharedStyles.bgCircleCircleCenter}`}></div>

                <div className={sharedStyles.formInnerWrapper} style={{ margin: 'auto' }}>
                    <h3 className={sharedStyles.formLogoText}>
                        {isRegister ? "Регистрация" : "Авторизация"}
                    </h3>

                    {/* STEP 1 — email */}
                    {step === 1 && (
                        <>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="Email"
                                className={styles.formControl}
                            />

                            {isRegister ?
                                // 🔥 НОВАЯ РАЗМЕТКА ДЛЯ ЧЕКБОКСА 🔥
                                <div className={styles.customCheckboxWrapper}>
                                    <label className={styles.customCheckboxLabel}>
                                        <input
                                            type="checkbox"
                                            checked={isAgreementChecked}
                                            onChange={() => setIsAgreementChecked(!isAgreementChecked)}
                                            className={styles.hiddenCheckbox}
                                        />
                                        <span className={styles.customCheckbox}></span>
                                        <span className={styles.checkboxText}>
                                            Согласен с
                                            <a rel="noreferrer noopener" target="_blank"
                                               href="https://api.arento.ru/policy/TermsOfUse.pdf"
                                               className={styles.termsLink}> Правилами использования</a>
                                            {' '} и {' '}
                                            <a rel="noreferrer noopener" target="_blank"
                                               href="https://api.arento.ru/policy/ConfidencePolicy.pdf"
                                               className={styles.termsLink}>Политикой конфиденциальности</a>
                                            {' '} Arento
                                        </span>
                                    </label>
                                </div>
                                :
                                <></>
                            }
                            <button
                                className={sharedStyles.button}
                                onClick={handleContinueEmail}
                            >
                                Продолжить
                            </button>

                            <div className={sharedStyles.formDescription}>
                                {isRegister ? (
                                    <span>
                                        Уже есть аккаунт?{' '}
                                        <button
                                            onClick={() => setIsRegister(false)}
                                            style={{
                                                color: '#1E88E5',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Войдите!
                                        </button>
                                    </span>
                                ) : (
                                    <span>
                                        Еще нет аккаунта?{' '}
                                        <button
                                            onClick={() => setIsRegister(true)}
                                            style={{
                                                color: '#1E88E5',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer'
                                            }}
                                        >
                                            Зарегистрируйтесь!
                                        </button>
                                    </span>
                                )}
                            </div>

                            <div>
                                <button
                                    onClick={() => setStep(2)}
                                    style={{
                                        color: '#1E88E5',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {isRegister ? "Зарегистрироваться с паролем" : "Войти с паролем"}
                                </button>
                            </div>
                        </>
                    )}

                    {/* STEP 2 — email + password (+ confirm если регистрация) */}
                    {step === 2 && (
                        <>
                            <input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder="Email"
                                className={styles.formControl}
                                style={{marginBottom: '10px'}}
                            />
                            <input
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Пароль"
                                className={styles.formControl}
                            />
                            {isRegister && (
                                <input
                                    type="password"
                                    value={confirmPassword}
                                    onChange={e => setConfirmPassword(e.target.value)}
                                    placeholder="Подтвердите пароль"
                                    className={styles.formControl}
                                    style={{marginTop: '10px'}}
                                />
                            )}
                            {isRegister ?
                                // 🔥 НОВАЯ РАЗМЕТКА ДЛЯ ЧЕКБОКСА 🔥
                                <div className={styles.customCheckboxWrapper}>
                                    <label className={styles.customCheckboxLabel}>
                                        <input
                                            type="checkbox"
                                            checked={isAgreementChecked}
                                            onChange={() => setIsAgreementChecked(!isAgreementChecked)}
                                            className={styles.hiddenCheckbox}
                                        />
                                        <span className={styles.customCheckbox}></span>
                                        <span className={styles.checkboxText}>
                                            Согласен с
                                            <a rel="noreferrer noopener" target="_blank"
                                               href="https://api.arento.ru/policy/TermsOfUse.pdf"
                                               className={styles.termsLink}> Правилами использования</a>
                                            {' '} и {' '}
                                            <a rel="noreferrer noopener" target="_blank"
                                               href="https://api.arento.ru/policy/ConfidencePolicy.pdf"
                                               className={styles.termsLink}>Политикой конфиденциальности</a>
                                            {' '} Arento
                                        </span>
                                    </label>
                                </div>
                                :
                                <></>
                            }
                            <button
                                className={styles.button}
                                onClick={handlePasswordSubmit}
                            >
                                {isRegister ? "Зарегистрироваться" : "Войти"}
                            </button>

                            <div style={{ marginTop: "15px" }}>
                                <button
                                    onClick={() => setStep(1)}
                                    style={{
                                        color: '#1E88E5',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer'
                                    }}
                                >
                                    {isRegister ? "Регистрация по коду" : "Авторизация по коду"}
                                </button>
                            </div>
                        </>
                    )}

                    {/* STEP 3 — подтверждение кода */}
                    {step === 3 && (
                        <>
                            <p className={sharedStyles.formDescription}>
                                Мы отправили код на вашу почту: <b>{email}</b>
                            </p>
                            <div style={{ display: "flex", gap: "8px", justifyContent: "center", marginBottom: "15px" }}>
                                {code.map((digit, idx) => (
                                    <input
                                        key={idx}
                                        type="text"
                                        maxLength="1"
                                        value={digit}
                                        onChange={e => handleCodeChange(e.target.value, idx)}
                                        className={sharedInputStyles.formControl}
                                        style={{ width: "40px", textAlign: "center" }}
                                        ref={el => (codeRefs.current[idx] = el)}
                                    />
                                ))}
                            </div>
                            <button className={sharedStyles.buttonSecondary} onClick={handleCodeSubmit}>
                                Подтвердить
                            </button>
                            <div style={{ marginTop: "15px" }}>
                                <button
                                    onClick={handleResendCode}
                                    style={{
                                        color: '#1E88E5',
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Отправить код повторно
                                </button>
                            </div>
                        </>
                    )}

                    {step === 4 && (
                        <>
                            <p className={sharedStyles.formDescription}>
                                Мы отправили письмо с подтверждением почты на Вашу почту: <b>{email}</b>
                            </p>
                            <p>
                                Перейдите по ссылке в письме чтобы подтвердить почту!
                            </p>
                            <button className={sharedStyles.buttonSecondary} onClick={onHide}>
                                Закрыть
                            </button>
                        </>
                    )}
                </div>
            </div>

            {/* Toast */}
            {toast && (
                <ToastNotification
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                />
            )}
        </div>
    );
};

export default RegistrationForm;